import { render, staticRenderFns } from "./organizationX6.vue?vue&type=template&id=5202db4b&scoped=true"
import script from "./organizationX6.vue?vue&type=script&lang=js"
export * from "./organizationX6.vue?vue&type=script&lang=js"
import style0 from "./organizationX6.vue?vue&type=style&index=0&id=5202db4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202db4b",
  null
  
)

export default component.exports